import { render, staticRenderFns } from "./SvehiclesalesorderView.vue?vue&type=template&id=b48f946c&scoped=true"
import script from "./SvehiclesalesorderView.vue?vue&type=script&lang=js"
export * from "./SvehiclesalesorderView.vue?vue&type=script&lang=js"
import style0 from "./SvehiclesalesorderView.vue?vue&type=style&index=0&id=b48f946c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b48f946c",
  null
  
)

export default component.exports